/**
 * Columbia Product Features Accordion
 * Handles expand/collapse functionality for feature accordions
 */

(function() {
  'use strict';

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    const accordions = document.querySelectorAll('.columbia-feature-accordion details');
    
    accordions.forEach(function(accordion) {
      const summary = accordion.querySelector('summary');
      const content = accordion.querySelector('.columbia-feature-accordion--content');
      const toggle = accordion.querySelector('.columbia-feature-accordion--toggle');
      
      if (!summary || !content || !toggle) return;
      
      // Prevent default details behavior
      summary.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const isOpen = accordion.hasAttribute('open');
        
        if (isOpen) {
          closeAccordion(accordion, content, toggle);
        } else {
          openAccordion(accordion, content, toggle);
        }
      });
      
      // Handle keyboard navigation
      summary.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          summary.click();
        }
      });
    });
  }

  function openAccordion(accordion, content, toggle) {
    accordion.setAttribute('open', '');
    
    // Set initial height for animation
    const startHeight = 0;
    const endHeight = content.scrollHeight;
    
    content.style.height = startHeight + 'px';
    content.style.overflow = 'hidden';
    
    // Force reflow
    content.offsetHeight;
    
    // Animate
    content.style.height = endHeight + 'px';
    content.style.transition = 'height 0.3s ease-out';
    
    // Update toggle
    toggle.textContent = '−';
    toggle.style.transform = 'rotate(0deg)';
    
    // Clean up after animation
    setTimeout(function() {
      content.style.height = '';
      content.style.overflow = '';
      content.style.transition = '';
    }, 300);
  }

  function closeAccordion(accordion, content, toggle) {
    const startHeight = content.scrollHeight;
    
    content.style.height = startHeight + 'px';
    content.style.overflow = 'hidden';
    
    // Force reflow
    content.offsetHeight;
    
    // Animate
    content.style.height = '0px';
    content.style.transition = 'height 0.3s ease-out';
    
    // Update toggle
    toggle.textContent = '+';
    toggle.style.transform = 'rotate(0deg)';
    
    // Remove open attribute after animation
    setTimeout(function() {
      accordion.removeAttribute('open');
      content.style.height = '';
      content.style.overflow = '';
      content.style.transition = '';
    }, 300);
  }
})();
